<template>
  <div class="userLog-main-content">
    <div class="search">

      <el-form class="searchForm" :model="searchForm">
        <el-form-item>
          <el-input size="small" v-model="searchForm.name" placeholder="产品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model="searchForm.pn" placeholder="件号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select clearable size="small" @change="search" v-model="searchForm.treeId" placeholder="所属车型">
            <el-option v-for="item in carList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>



        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>

      </el-form>

    </div>
    <div class="table">
      <!-- table start -->
      <el-table stripe size="medium" :data="list" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column prop="car" label="车型" align="center" min-width="120"></el-table-column>

        <el-table-column prop="cname" label="分类" align="center" min-width="120"></el-table-column>
        <el-table-column prop="sort" label="Grade" align="center" min-width="40"></el-table-column>
        <el-table-column prop="name" label="产品名称" align="center" min-width="120"></el-table-column>
        <el-table-column prop="pn" label="PN" align="center" min-width="120"></el-table-column>
        <el-table-column prop="replacePn" label="Replace PN" min-width="80"></el-table-column>


        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- table end -->

      <!-- page start -->
      <Pagination :params="pageParams" @pageList="pageList"></Pagination>
      <!-- page end -->

      <!-- edit start -->
      <el-dialog :title="editTitle" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
        <el-form label-width="140px" :model="formData" :rules="rules" ref="formData">

          <el-form-item style="margin-bottom:6px;" label="产品名称" prop="name">
            <el-input size="small" style="width:80%" v-model="formData.name" class="form-input"></el-input>
          </el-form-item>


          <el-form-item style="margin-bottom:6px;" label="PN" prop="pn">
            <el-input size="small" style="width:80%" v-model="formData.pn" class="form-input"></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="Grade">
            <el-input size="small" style="width:80%" v-model="formData.sort" class="form-input"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:6px;" label="ReplacePN">
            <el-input size="small" style="width:80%" v-model="formData.replacePn" class="form-input"></el-input>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary" @click="submitForm('formData')">提交保存</el-button>
            <el-button size="small" @click="closeDialog">取消</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        </div>
      </el-dialog>
      <!-- edit end -->

    </div>
  </div>
</template>

<script>
import { item_page2, tree_car_list, user_add, item_update, item_del, userLog_list_by_user, user_refresh_token } from "../api/api";
import './../assets/css/userLog.css';
import Pagination from "../components/Pagination";
import UserLogsTimeline from "../components/UserLogsTimeline";

export default {
  data() {
    return {
      timer: null, // 定时器

      // 页面控制元素
      loading: false, //是否显示加载
      editTitle: '', //编辑页面标题
      editType: 1, // 新增/修改
      editFormVisible: false, // 编辑页面显隐
      editFormVisibleUserLog: false, // 用户操作记录对话框

      // 搜索表单
      searchForm: {
        name: '',
        pn: '',
        treeId: null
      },

      // 分页表单
      pageParams: {
        currentPage: 1,
        pageSize: 25,
        total: 0
      },

      // 编辑表单
      formData: {
        id: "",
        name: "",
        pn: "",
        sort: "",
        replacePn: ""
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        pn: [{ required: true, message: "请输入PN", trigger: "blur" }]
      },

      // 列表
      list: [],
      carList: [],

    };
  },
  // 注册组件
  components: { Pagination, UserLogsTimeline },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end
    this.queryCarList();
    this.page(this.pageParams.currentPage, this.pageParams.pageSize);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken();
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userinfo", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    async queryCarList() {
      const data = await tree_car_list();
      this.carList = data.data
    },
    // ----------------------search start---------------------
    search() {
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    reset() {
      this.searchForm.name = '';
      this.searchForm.pn = '';
      this.searchForm.treeId = null;
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },

    // 分页插件事件
    pageList(currentPage, pageSize) {
      this.page(currentPage, pageSize);
    },
    // 分页查询
    async page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;

      param.name = this.searchForm.name;
      param.pn = this.searchForm.pn;
      param.treeId = this.searchForm.treeId;

      const data = await item_page2(param);

      this.pageParams.total = data.data.total;
      this.pageParams.pageSize = data.data.pageSize;
      this.pageParams.currentPage = data.data.currentPage;
      this.list = data.data.list;

      if (this.pageParams.total > 0 && this.pageParams.total == (this.pageParams.currentPage - 1) * this.pageParams.pageSize) {
        this.getData(this.pageParams.currentPage - 1, this.pageParams.pageSize, this.pageParams.city);
      } else {
        this.list = data.data.list;
      }
    },
    // ----------------------search end---------------------

    // ----------------------add start---------------------
    handleEdit: function (row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.editTitle = "修改产品信息";
        this.editType = 2;

        this.formData.id = row.id;
        this.formData.treeId = row.treeId;
        this.formData.name = row.name;
        this.formData.pn = row.pn;
        this.formData.sort = row.sort;
        this.formData.replacePn = row.replacePn;
      } else {
      }
    },

    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editType == 1) {
            this.add(this.formData);
          }
          else if (this.editType == 2) {
            this.update(this.formData);
          }
          this.editFormVisible = false;
          this.loading = false;
        } else {
          return false;
        }
      });
    },
    async update() {
      await item_update(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },

    clearFormData() {
      this.formData.id = "";
      this.formData.name = "";
      this.formData.pn = "";
      this.formData.sort = "";
      this.formData.replacePn = "";
    },
    closeDialog() {
      this.clearFormData();
      this.editFormVisible = false;
    },
    closeDialogUserLog() {
      this.clearFormData();
      this.editFormVisibleUserLog = false;
    },


    // ----------------------add end-----------------------


    // ----------------------delete start-------------------
    // 删除文章
    handleDelete(index, id) {
      this.delConfirm(index, id);
    },
    //删除确认对话框
    delConfirm(index, id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          item_del(id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.list.splice(index, 1);
              this.page(
                this.pageParams.currentPage,
                this.pageParams.pageSize
              );
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------delete end---------------------

  }
};
</script>



// WEBPACK FOOTER //
// src/views/Item.vue